import env from '@beam-australia/react-env';

const featureToggleEnabled = (name) => {
  const value = env(name);
  return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
};

const isAnalyticsEnabled = () => featureToggleEnabled('SITE_TRACKING_ENABLED');

export const isPmnTransferEnabled = () => featureToggleEnabled('PMN_API_ENABLED');

export const isCommonsModeEnabled = () => featureToggleEnabled('ENABLE_DATA_COMMONS');

export default isAnalyticsEnabled;
